import type { FC, MouseEvent } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import type { ITheme } from '@homeviews/styles'
import { DownloadIcon } from '@homeviews/svg'
import { Typography } from '@homeviews/shared-ui'
import { mixpanelTrack, EVENTS } from '@homeviews/seo'

import { exportTableAsCsv } from '@homeviews/utils'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      transition: 'all .2s ease-in-out',
      width: 23,
      height: 23,
      border: '1px solid #DEE1E6',
      borderRadius: '11.5px',
      overflow: 'hidden',
      justifyContent: 'flex-start!important',
      paddingLeft: 5,
      marginRight: 5,
      '&:hover': {
        cursor: 'pointer',
        width: '141px!important',
      },
      '& svg': {
        flexShrink: 0,
      },
    },
    title: {
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '22px',
      marginLeft: 6,
      whiteSpace: 'nowrap',
    },
  }),
)

interface IProps {
  onClick: (callback: any) => void
}

const CsvExportButton: FC<IProps> = ({ onClick }) => {
  const classes = useStyles()

  function handleClick(e: MouseEvent<HTMLDivElement>) {
    onClick(exportTableAsCsv)

    const card: HTMLElement = e.currentTarget.closest('.c-card')

    if (!card) {
      console.warn('Card component is not a parent')
    }

    const eventName = card.dataset?.eventName

    if (eventName) {
      mixpanelTrack(`DOWNLOAD_${eventName}`)
    }
  }

  return (
    <div
      onClick={handleClick}
      className={clsx('l-center', classes.root, 'c-csvExportButton')}
      style={{
        width: 23,
      }}
    >
      <DownloadIcon />
      <Typography className={classes.title}>Download CSV File</Typography>
    </div>
  )
}

export default CsvExportButton
